import { Box, Dialog, DialogContent, DialogTitle, Grid, Button, Typography } from '@mui/material';
import AceEditor from 'react-ace';
import ace from 'ace-builds/src-noconflict/ace';
import { usePrerequisites } from '../Prerequisites';
import util from '../../util';
import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/theme-github';

// Map Ace's xml worker module to the actual file URL
ace.config.setModuleUrl(
  'ace/mode/xml_worker',
  new URL('ace-builds/src-noconflict/worker-xml.js', import.meta.url).toString()
);

const XmlEditorDialog = ({
	xmlEditorOpen,
	xmlEditorValue,
	xmlEditorTitle,
	onChangeXmlValue,
	fullscreenDialogs: fullScreen,
	onCloseXmlEditorDialog,
	xmlFileName
}) => {
	const [{ strings }] = usePrerequisites();
	const handleOnSave = async () => {
		try {
			const blob = new Blob([xmlEditorValue], { type: "application/xml" });
			const url = URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = xmlFileName;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
			util.showError(strings.SaveToLocalStorageSuccess, strings.Info, 'info');
		} catch (error) {
			util.showError(strings.SaveToLocalStorageFailed, strings.Error, "error");
		}
	}
	return (
		<Dialog onClose={onCloseXmlEditorDialog} open={xmlEditorOpen} fullscreen={fullScreen} fullWidth>
			<DialogTitle>
				<Box display="flex" alignItems={'center'} flexDirection="row" columnGap={1}>
					<Box flex={1}>
						<Typography fontSize={'inherit'} fontWeight={'inherit'}>
							{xmlEditorTitle || strings.XMLName}
						</Typography>
					</Box>
					<Button
						onClick={handleOnSave}
						color="primary"
						variant="contained"
						size="small"
						sx={{
							px: 1,
							fontSize: 14,
							textTransform: 'uppercase',
							fontWeight: 'bold',
						}}
					>
						{strings.Save}
					</Button>
					<Button
						onClick={onCloseXmlEditorDialog}
						title={strings.Close}
						color="error"
						variant="contained"
						size="small"
						sx={{
							px: 1,
							fontSize: 14,
							textTransform: 'uppercase',
							fontWeight: 'bold',
						}}
					>
						{strings.Close}
					</Button>
				</Box>
			</DialogTitle>
			<DialogContent>
				<Grid container>
					<Grid size={12}>
						<AceEditor
							mode="xml"
							onChange={onChangeXmlValue}
							editorProps={{ $blockScrolling: true }}
							width={'100%'}
							value={xmlEditorValue}
							readOnly="true"
						/>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default XmlEditorDialog;
